import { useEffect } from "react";
import Button from "../components/Button";
import { renderStrapiContent } from "../utils/contentfulOptions";
import FullPageLoader from "../components/FullPageLoader";
import CornerBison from "../images/corner/corner-bison.webp";
import StrapiImage from "../components/StrapiImage";

const TOCK_URL = "https://www.exploretock.com/auburnroadvineyards/";

const Cowtown = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - Cowtown Covered Wagon Tours";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  const cards = info.card || [];

  return (
    <>
      <img className="corner-bison" src={CornerBison} alt="" />
      <div className="container content-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">Wagon tours</p>
          <h1 className="huge-text-no-quote content-hero__title">
            {info.Heading}
          </h1>
          <p className="content-hero__intro">
            Climb aboard for a covered-wagon tour through the vineyard, then
            stay for wine, food, and music.
          </p>
          <Button className="m-t-20" type="secondary" href={TOCK_URL}>
            Get Tickets
          </Button>
        </section>

        <section className="content-story">
          <div className="content-story__media">
            <div className="content-media content-media--tall">
              <iframe
                src="https://youtube.com/embed/BLA1kZFAn7c?si=MmZi-Cfxb1b2SbCY"
                title="cowtown video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          <div className="content-story__copy">
            {renderStrapiContent(info.body)}
            <Button className="m-t-20" type="secondary" href={TOCK_URL}>
              Get Tickets
            </Button>
          </div>
        </section>

        {cards.length > 0 && (
          <div className="content-tiles">
            {cards.map((card, index) => {
              const [buttonText, link] = (card.description || "").split("-");
              const image = StrapiImage(card.image?.[0]);
              return (
                <article key={card.id || index} className="content-tile">
                  <img
                    className="content-tile__photo"
                    src={image}
                    alt={card.Title || ""}
                  />
                  <p className="content-tile__title">{card.Title}</p>
                  {link && (
                    <Button type="secondary" href={link.trim()}>
                      {(buttonText || "Learn more").trim()}
                    </Button>
                  )}
                </article>
              );
            })}
          </div>
        )}

        <div className="content-note">
          <h2 className="content-note__heading">Don't forget...</h2>
          <p>Make reservations for before or after your tour at Auburn Road!</p>
          <Button className="m-t-10" type="secondary" href={TOCK_URL}>
            Make a Reservation
          </Button>
        </div>
      </div>
    </>
  );
};

export default Cowtown;
